import * as moment from 'moment';
import * as g from 'src/app/globals';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  EventType,
  RecordCategory,
  RecordLine,
  RecordModel,
  RecordProperties,
} from 'src/app/layout/record-model';
import { FieldDataType, ModuleStructure } from '../module-structure';
import { LineDeletedArgs } from '../lineDeletedArgs';
import { FieldValueChangedArgs } from '@app/layout/field-value-changed-args';
import { CellValueChangedArgs } from '@app/layout/cell-value-changed-args';
import { NzNotificationService } from 'ng-zorro-antd/notification';

export class Wms {
  static validateBeforeSubmit(recordModel: RecordModel) {
    if (recordModel.ObjectKey === 'ITM_WMS_QTY_PLAN') {
      recordModel.Categories.forEach((category) => {
        if (category.Id.startsWith('Quantity_Distribution_')) {
          category.Lines = [];
          if (category.Dataset !== undefined) {
            category.Dataset.forEach((element) => {
              /*const lineIsSelected =
                element.U_ITM_RELEASE_QTY != null &&
                element.U_ITM_RELEASE_QTY !== undefined &&
                element.U_ITM_RELEASE_QTY !== '' &&
                Number(element.U_ITM_RELEASE_QTY) !== 0;*/
              //if (lineIsSelected) {
              const columnDocEntry = 'DocEntry';
              const columnLineNum = 'LineNum';
              const columnU_ITM_RELEASE_QTY = 'U_ITM_RELEASE_QTY';

              let recordLine: RecordLine = null;
              recordLine = {
                Id: category.Lines.length,
                Properties: [],
              };
              let recordProperty: RecordProperties = {
                DataType: FieldDataType.String,
                Name: 'DocEntry',
                FieldName: 'DocEntry',
                ValueAsObject: element[columnDocEntry],
              };
              recordLine.Properties.push(recordProperty);

              recordProperty = {
                DataType: FieldDataType.String,
                Name: 'LineNum',
                FieldName: 'LineNum',
                ValueAsObject: element[columnLineNum],
              };
              recordLine.Properties.push(recordProperty);

              recordProperty = {
                DataType: FieldDataType.String,
                Name: 'U_ITM_RELEASE_QTY',
                FieldName: 'U_ITM_RELEASE_QTY',
                ValueAsObject: element[columnU_ITM_RELEASE_QTY],
              };
              recordLine.Properties.push(recordProperty);

              category.Lines.push(recordLine);
              //}
            });

            category.Dataset = [];
          }
        }
      });
    }
  }

  constructor(
    private layoutService: LayoutService,
    private notificationService: NzNotificationService,
    private messageService: NzMessageService
  ) {
    layoutService.shrinkRecordModel.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        Wms.validateBeforeSubmit(args.recordModel);
      }
    );
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      try {
        this.oWMS(args);
      } catch (e) {
        console.log('An error occured while trying to execute oWMS', args, e);
      }
    });

    this.layoutService.cellValueChanged.subscribe(
      (args: CellValueChangedArgs) => {
        this.oWMSCell(args);
      }
    );

    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        try {
          this.ObjectLoad(args.recordModel, args.moduleStructure);
        } catch (e) {
          console.log('error during loading the object, the error is:', e);
        }
      }
    );

    this.layoutService.deleteRowEmitter.subscribe((args) => {
      //console.log(args);
      this.IsGoingToBeRemoved(args);
    });
  }
  oWMS(args: FieldValueChangedArgs) {
    const currentObject = args.recordModel.ObjectKey;
    if (currentObject === 'ITM_WMS_DEL_PLT') {
      console.log(args);
      if (args.recordProperty.Name === 'SSCC_CITY') {
        const headerLine = args.recordModel.Categories.find(
          (cat) => cat.Id === 'ITM_WMS_DEL_PLT'
        ).Lines[0];

        headerLine.Properties.find(
          (p) => p.Name === 'SCANNED_PLT'
        ).ValueAsObject = 0;

        const linesSection = args.recordModel.Categories.find(
          (cat) => cat.Id === 'ITM_WMS_DEL_PLT_LINE'
        );
        linesSection.Lines = [];

        this.layoutService.linesChanged.emit(linesSection);

        if (args.recordProperty.ValueAsObject === '') {
        }
      }
    }
    if (currentObject === 'ITM_WMS_PLT_BOX') {
      if (
        args.recordProperty.Name === 'U_ITEM_CODE' ||
        args.recordProperty.Name === 'ITM_BOXES_CAPACITY'
      ) {
        const linesSection = args.recordModel.Categories.find(
          (cat) => cat.Id === 'ITM_WMS_PLT_LINE'
        );

        const currentItemCode = linesSection.Lines[args.line].Properties.find(
          (p) => p.Name === 'U_ITEM_CODE'
        ).ValueAsObject;

        const boxCapacity = linesSection.Lines[args.line].Properties.find(
          (p) => p.Name === 'ITM_BOXES_CAPACITY'
        ).ValueAsObject;

        let totalLoaded = 0.0;

        for (let i = 0; i < linesSection.Lines.length; i++) {
          const properties = linesSection.Lines[i].Properties;
          const itemCode = properties.find(
            (p) => p.Name === 'U_ITEM_CODE'
          ).ValueAsObject;
          if (itemCode !== currentItemCode) {
            continue;
          }
          const qtyProp = properties.find((p) => p.Name === 'U_QTY');
          totalLoaded += qtyProp.ValueAsObject;
        }

        console.log(args);
        console.log(totalLoaded / boxCapacity);

        for (let i = 0; i < linesSection.Lines.length; i++) {
          const properties = linesSection.Lines[i].Properties;
          const itemCode = properties.find(
            (p) => p.Name === 'U_ITEM_CODE'
          ).ValueAsObject;
          if (itemCode !== currentItemCode) {
            continue;
          }

          const totalLodedBoxProp = properties.find(
            (p) => p.Name === 'ITM_TOTAL_LOADED'
          );

          if (
            boxCapacity != null &&
            boxCapacity !== undefined &&
            boxCapacity !== ''
          )
            totalLodedBoxProp.ValueAsObject = Number(totalLoaded / boxCapacity);

          this.layoutService.triggerFieldValueChanged({
            recordProperty: totalLodedBoxProp,
            formId: '',
            line: linesSection.Lines[i].Id,
            recordModel: args.recordModel,
            sectionTagName: 'ITM_WMS_PLT_LINE',
            moduleStructure: args.moduleStructure,
          });
        }
      } else if (args.recordProperty.Name === 'ITM_REMAIN_BOXES_TO_LOAD') {
        const linesSection = args.recordModel.Categories.find(
          (cat) => cat.Id === 'ITM_WMS_PLT_LINE'
        );
        const remainQty = linesSection.Lines[args.line].Properties.find(
          (p) => p.Name === 'ITM_REMAIN_BOXES_TO_LOAD'
        ).ValueAsObject;
        if (remainQty < 0 && linesSection.Lines.length === 1) {
          const currentItemCode = linesSection.Lines[args.line].Properties.find(
            (p) => p.Name === 'U_ITEM_CODE'
          ).ValueAsObject;

          this.messageService.error(
            this.layoutService
              .translate(
                `The required quantity for item _ITEM_CODE_ is already fulfilled, you can't add more boxes to the pallet`
              )
              .replace('_ITEM_CODE_', currentItemCode)
          );
          this.playErrorVoice();

          linesSection.Lines.pop();
          this.layoutService.linesChanged.emit(linesSection);
        }
      }
    }
    /*if (currentObject === 'ITM_WMS_BOX_DCLR') {
      const lines = args.recordModel.Categories.find(
        (cat) => cat.Id === 'ITM_WMS_BOX_LINE'
      ).Lines;

      for (let i = 0; i < lines.length; i++) {
        const properties = lines[i].Properties;
        const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

        console.log(boxProp);

        /*if (
          boxProp != null &&
          boxProp !== undefined &&
          boxCode === boxProp.ValueAsObject
        ) {
          this.rowToWorkWith = this.lines[i];
          this.message.error(
            this.layoutService.translate(`You already scan the box with code`) +
              ' ' +
              boxCode
          );
          this.playErrorVoice();
          return;
        }
      }
    }*/

    if (currentObject === 'oPickLists') {
      if (args.recordProperty.Name !== 'PickedQuantity') {
        return;
      }

      const section = args.recordModel.Categories.find(
        (x) => x.Id === args.sectionTagName
      );

      const rowToWorkWith = section.Lines.find((l) => l.Id === args.line);
      const properties = rowToWorkWith.Properties;
      const releasedQuantity = properties.find(
        (p) => p.Name === 'ReleasedQuantity'
      );

      const orig_PickedQuantity = properties.find(
        (p) => p.Name === 'Orig_PickedQuantity'
      );
      let tempNewVal =
        args.recordProperty.ValueAsObject == null ||
        args.recordProperty.ValueAsObject === undefined ||
        args.recordProperty.ValueAsObject.toString() === ''
          ? 0
          : parseFloat(args.recordProperty.ValueAsObject);
      let tempMaxVal =
        parseFloat(releasedQuantity.ValueAsObject) +
        (orig_PickedQuantity.ValueAsObject == null ||
        orig_PickedQuantity.ValueAsObject === undefined ||
        orig_PickedQuantity.ValueAsObject.toString() === ''
          ? 0
          : parseFloat(orig_PickedQuantity.ValueAsObject));

      if (tempNewVal > tempMaxVal) {
        this.notificationService.create(
          'warning',
          this.layoutService.translate(
            'The selected quantity ' +
              tempNewVal +
              ' exceeds the released quantity' +
              tempMaxVal
          ),
          ''
        );

        let audio = new Audio('assets/audio_file.mp3');
        audio.load();
        audio.play();

        args.recordProperty.ValueAsObject = 0;
        args.recordProperty.Value = '0';

        this.layoutService.triggerFieldValueChanged({
          recordModel: args.recordModel,
          recordProperty: args.recordProperty,
          formId: '',
          line: args.line,
          sectionTagName: args.sectionTagName,
          moduleStructure: args.moduleStructure,
        });

        return;
      }

      const batchToWorkWithProp = rowToWorkWith.Properties.find(
        (p) => p.Name === 'BatchNumber'
      );

      if (
        batchToWorkWithProp == null ||
        batchToWorkWithProp === undefined ||
        batchToWorkWithProp.Value === ''
      ) {
        return;
      }

      const binActivateProp = rowToWorkWith.Properties.find(
        (p) => p.Name === 'BinActivate'
      );
      if (binActivateProp !== undefined) {
        rowToWorkWith['BinActivate'] = binActivateProp.ValueAsObject;
      } else {
        rowToWorkWith['BinActivate'] = 'N';
      }

      let itmSerialNumber = rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'ITMSerialNumber'
      )?.ValueAsObject as string;

      if (itmSerialNumber == null || itmSerialNumber === undefined) {
        itmSerialNumber = '';
      }

      let existingRecs = [];

      if (
        itmSerialNumber == null ||
        itmSerialNumber === undefined ||
        itmSerialNumber === ''
      ) {
        let baseLine = rowToWorkWith.Properties.find(
          (prop) => prop.Name === 'BaseLine'
        )?.ValueAsObject;
        if (baseLine == null || baseLine === undefined || baseLine === '') {
          baseLine = '-1';
        }

        this.layoutService
          .executeQuery(2765, {
            Scan: batchToWorkWithProp.Value,
            BaseEntry: args.recordModel.SourceObjectId,
            ObjectType: args.moduleStructure.module.ObjectType,
            BaseLine: baseLine,
          })
          .subscribe((result: any) => {
            console.log('batch scanned result', result);

            if (result.length === 0) {
              return;
            }

            let binAbs = rowToWorkWith.Properties.find(
              (p) => p.Name === 'BinAbs'
            );
            if (binAbs == null || binAbs === undefined) {
              binAbs = rowToWorkWith.Properties.find(
                (p) => p.Name === 'BinEntry'
              );
            }

            let numPerSale = 1;
            if (
              rowToWorkWith.Properties.find(
                (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt'
              ) === undefined
            ) {
              numPerSale = 1;
            } else {
              numPerSale = rowToWorkWith.Properties.find(
                (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt'
              ).ValueAsObject as number;
            }

            let dbBatch = result[0].DistNumber;
            let expDate = result[0].ExpDate;
            let mnfSerial = result[0].MnfSerial;
            let inDate = result[0].InDate;

            if (rowToWorkWith['BinActivate'] === 'Y') {
              existingRecs.push({
                Quantity: args.recordProperty.ValueAsObject * numPerSale,
                BatchNumber: batchToWorkWithProp.Value,
                ExpDate: expDate,
                AddmisionDate: inDate,
                MnfSerial: mnfSerial,
                BinLocation: binAbs.ValueAsObject,
                FromBinLocation: binAbs.ValueAsObject,
              });
            } else {
              existingRecs.push({
                Quantity: args.recordProperty.ValueAsObject * numPerSale,
                BatchNumber: batchToWorkWithProp.Value,
                ExpDate: expDate,
                AddmisionDate: inDate,
                MnfSerial: mnfSerial,
              });
            }

            const jsonToSave = JSON.stringify(existingRecs);

            rowToWorkWith.Properties.find(
              (prop) => prop.Name === 'ITMSerialNumber'
            ).ValueAsObject = jsonToSave.substring(1, jsonToSave.length - 1);
          });
        return;
      }

      if (itmSerialNumber.startsWith(',{')) {
        itmSerialNumber = itmSerialNumber.substring(1);
      }
      existingRecs = JSON.parse(`[${itmSerialNumber}]`);
      const foundedBatch = existingRecs.find(
        (d) => d.BatchNumber === batchToWorkWithProp.Value
      );
      if (foundedBatch == null || foundedBatch === undefined) {
        let baseLine = rowToWorkWith.Properties.find(
          (prop) => prop.Name === 'BaseLine'
        )?.ValueAsObject;
        if (baseLine == null || baseLine === undefined || baseLine === '') {
          baseLine = '-1';
        }

        this.layoutService
          .executeQuery(2765, {
            Scan: batchToWorkWithProp.Value,
            BaseEntry: args.recordModel.SourceObjectId,
            ObjectType: args.moduleStructure.module.ObjectType,
            BaseLine: baseLine,
          })
          .subscribe((result: any) => {
            console.log('batch scanned result', result);

            if (result.length === 0) {
              return;
            }

            let binAbs = rowToWorkWith.Properties.find(
              (p) => p.Name === 'BinAbs'
            );
            if (binAbs == null || binAbs === undefined) {
              binAbs = rowToWorkWith.Properties.find(
                (p) => p.Name === 'BinEntry'
              );
            }

            let numPerSale = 1;
            if (
              rowToWorkWith.Properties.find(
                (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt'
              ) === undefined
            ) {
              numPerSale = 1;
            } else {
              numPerSale = rowToWorkWith.Properties.find(
                (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt'
              ).ValueAsObject as number;
            }

            let dbBatch = result[0].DistNumber;
            let expDate = result[0].ExpDate;
            let mnfSerial = result[0].MnfSerial;
            let inDate = result[0].InDate;

            if (rowToWorkWith['BinActivate'] === 'Y') {
              existingRecs.push({
                Quantity: args.recordProperty.ValueAsObject * numPerSale,
                BatchNumber: batchToWorkWithProp.Value,
                ExpDate: expDate,
                AddmisionDate: inDate,
                MnfSerial: mnfSerial,
                BinLocation: binAbs.ValueAsObject,
                FromBinLocation: binAbs.ValueAsObject,
              });
            } else {
              existingRecs.push({
                Quantity: args.recordProperty.ValueAsObject * numPerSale,
                BatchNumber: batchToWorkWithProp.Value,
                ExpDate: expDate,
                AddmisionDate: inDate,
                MnfSerial: mnfSerial,
              });
            }

            const jsonToSave = JSON.stringify(existingRecs);

            rowToWorkWith.Properties.find(
              (prop) => prop.Name === 'ITMSerialNumber'
            ).ValueAsObject = jsonToSave.substring(1, jsonToSave.length - 1);
          });
        return;
      }

      foundedBatch.Quantity = args.recordProperty.ValueAsObject;

      const jsonToSave = JSON.stringify(existingRecs);

      rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'ITMSerialNumber'
      ).ValueAsObject = jsonToSave.substring(1, jsonToSave.length - 1);
    }
  }

  oWMSCell(args: CellValueChangedArgs) {
    const currentObject = args.recordModel.ObjectKey;
    if (currentObject !== 'ITM_WMS_QTY_PLAN') {
      return;
    }

    const row = args.row;
    const openQty = Number(args.dataset[row]['OpenQty']);
    const releasedQty = Number(args.dataset[row]['U_ITM_RELEASE_QTY']);

    if (releasedQty > openQty) {
      this.messageService.error(
        this.layoutService.translate(
          `The released quantity is more than the open quantity`
        )
      );
      args.dataset[row]['U_ITM_RELEASE_QTY'] = '0';
      this.playErrorVoice();
    }
  }

  playErrorVoice() {
    let audio = new Audio('assets/audio_file.mp3');
    audio.load();
    audio.play();
  }

  ObjectLoad(recordModel: RecordModel, moduleStructure: ModuleStructure) {
    if (recordModel.ObjectKey === 'ITM_WMS_PLT_BOX') {
      const headerCat = recordModel.Categories.find(
        (cat) => cat.Id === 'ITM_WMS_PLT_SSCC'
      );

      const pltStatus = headerCat.Lines[0].Properties.find(
        (p) => p.Name === 'U_PLT_STATUS'
      ).ValueAsObject;

      if (pltStatus === 'D') return;

      setTimeout(() => {
        const linesSection = recordModel.Categories.find(
          (cat) => cat.Id === 'ITM_WMS_PLT_LINE'
        );

        for (let i = 0; i < linesSection.Lines.length; i++) {
          const properties = linesSection.Lines[i].Properties;
          const itemCodeProp = properties.find((p) => p.Name === 'U_BOX_CODE');

          this.layoutService.triggerFieldValueChanged({
            recordProperty: itemCodeProp,
            formId: '',
            line: linesSection.Lines[i].Id,
            recordModel: recordModel,
            sectionTagName: 'ITM_WMS_PLT_LINE',
            moduleStructure: moduleStructure,
          });
        }

        this.layoutService.recordModelChanged = false;
      }, 1000);
    }

    const batchCat = recordModel.Categories.find(
      (id) => id.Id === 'Document_Lines_Batches'
    );

    const serialCat = recordModel.Categories.find(
      (id) => id.Id === 'Document_Lines_Serials'
    );

    const nonInvCat = recordModel.Categories.find(
      (id) => id.Id === 'Document_Lines_Non'
    );

    if (
      batchCat === undefined ||
      nonInvCat === undefined ||
      serialCat === undefined
    ) {
      return;
    }

    if (
      moduleStructure.module.ObjectType === 'ITM_WMS_SSCC' &&
      recordModel.EventType === EventType.Create
    ) {
      return;
    }

    const linesCat = recordModel.Categories.find(
      (id) => id.Id === 'Document_Lines'
    );
    const batches = [];
    for (const line of batchCat.Lines) {
      const batch = line.Properties.find(
        (p) => p.Name === 'BatchNumber'
      ).ValueAsObject;
      const quantity = line.Properties.find(
        (p) => p.Name === 'Quantity'
      ).ValueAsObject;
      const expDate = line.Properties.find(
        (p) => p.Name === 'ExpDate'
      ).ValueAsObject;
      const lineNum = line.Properties.find(
        (p) => p.Name === 'LineNum'
      ).ValueAsObject;
      const ssccProp = line.Properties.find((p) => p.Name === 'U_SSCC');

      const batchDetails = {
        Quantity: quantity,
        ExpDate: expDate, //moment(moment(expDate).toDate()).format(g.companyConfiguration.MomentDateFormat),
        AddmisionDate: '',
        ManufacturingDate: '',
        BatchNumber: batch,
        BinLocation: '',
        U_ITM_WMS_SSCC: ssccProp === undefined ? '' : ssccProp.ValueAsObject,
      };

      const lineToWorkOn = linesCat.Lines.find(
        (p) =>
          p.Properties.find((l) => l.Name === 'LineNum').ValueAsObject ===
          lineNum
      );

      if (lineToWorkOn !== undefined) {
        const itmSerialNumber = lineToWorkOn.Properties.find(
          (p) => p.Name === 'ITMSerialNumber'
        );
        const quantityProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'Quantity'
        );
        const unitPerMsrProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'UnitsOfMeasurment'
        );

        if (itmSerialNumber.ValueAsObject === '') {
          itmSerialNumber.ValueAsObject = JSON.stringify(batchDetails);
        } else {
          itmSerialNumber.ValueAsObject += ',' + JSON.stringify(batchDetails);
        }

        if (unitPerMsrProp !== undefined) {
          if (
            Number(quantityProp.ValueAsObject) === 0 ||
            quantityProp['ItWasZero']
          ) {
            quantityProp['ItWasZero'] = true;
            quantityProp.ValueAsObject =
              Number(quantityProp.ValueAsObject) +
              quantity / unitPerMsrProp.ValueAsObject;

            lineToWorkOn.QuantityProp = lineToWorkOn.Properties.find(
              (p) =>
                p.Name === 'Quantity' ||
                p.Name === 'UoMCountedQuantity' ||
                p.Name == 'PickedQuantity'
            );
            lineToWorkOn.OpenQtyProp = lineToWorkOn.Properties.find(
              (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity'
            );
          }
        }
      }

      batches.push(batchDetails);
    }

    const serials = [];
    for (const line of serialCat.Lines) {
      const absEntry = line.Properties.find(
        (p) => p.Name === 'AbsEntry'
      ).ValueAsObject;

      const lineNum = line.Properties.find(
        (p) => p.Name === 'LineNum'
      ).ValueAsObject;

      const serialDetails = absEntry;

      const lineToWorkOn = linesCat.Lines.find(
        (p) =>
          p.Properties.find((l) => l.Name === 'LineNum').ValueAsObject ===
          lineNum
      );

      if (lineToWorkOn !== undefined) {
        const itmSerialNumber = lineToWorkOn.Properties.find(
          (p) => p.Name === 'ITMSerialNumber'
        );
        const quantityProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'Quantity'
        );
        const unitPerMsrProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'UnitsOfMeasurment'
        );

        if (itmSerialNumber.ValueAsObject === '') {
          itmSerialNumber.ValueAsObject = JSON.stringify(serialDetails);
        } else {
          itmSerialNumber.ValueAsObject += ',' + JSON.stringify(serialDetails);
        }

        if (unitPerMsrProp !== undefined) {
          if (
            Number(quantityProp.ValueAsObject) === 0 ||
            quantityProp['ItWasZero']
          ) {
            quantityProp['ItWasZero'] = true;
            quantityProp.ValueAsObject =
              Number(quantityProp.ValueAsObject) +
              1 / unitPerMsrProp.ValueAsObject;

            lineToWorkOn.QuantityProp = lineToWorkOn.Properties.find(
              (p) =>
                p.Name === 'Quantity' ||
                p.Name === 'UoMCountedQuantity' ||
                p.Name == 'PickedQuantity'
            );
            lineToWorkOn.OpenQtyProp = lineToWorkOn.Properties.find(
              (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity'
            );
          }
        }
      }

      serials.push(serialDetails);
    }

    const bins = [];
    for (const line of nonInvCat.Lines) {
      const itemCode = line.Properties.find(
        (p) => p.Name === 'U_ItemCode'
      ).ValueAsObject;
      const uomEntry = line.Properties.find(
        (p) => p.Name === 'U_UomEntry'
      ).ValueAsObject;
      const uomCode = line.Properties.find(
        (p) => p.Name === 'U_UomCode'
      ).ValueAsObject;
      const quantity = line.Properties.find(
        (p) => p.Name === 'Quantity'
      ).ValueAsObject;
      const lineNum = line.Properties.find(
        (p) => p.Name === 'LineNum'
      ).ValueAsObject;

      const binLocation = line.Properties.find(
        (p) => p.Name === 'BinLocation'
      ).ValueAsObject;

      const ssccProp = line.Properties.find((p) => p.Name === 'U_SSCC');

      const lineToWorkOn = linesCat.Lines.find(
        (p) =>
          p.Properties.find((l) => l.Name === 'LineNum').ValueAsObject ===
          lineNum
      );

      if (lineToWorkOn !== undefined) {
        const itmSerialNumber = lineToWorkOn.Properties.find(
          (p) => p.Name === 'ITMSerialNumber'
        );

        if (binLocation != '') {
          const binDetails = {
            Quantity: quantity,
            BinLocation: binLocation,
            FromBinLocation: binLocation,
          };

          if (itmSerialNumber.ValueAsObject === '') {
            itmSerialNumber.ValueAsObject = JSON.stringify(binDetails);
          } else {
            itmSerialNumber.ValueAsObject += ',' + JSON.stringify(binDetails);
          }

          bins.push(binDetails);
        }

        const quantityProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'Quantity'
        );
        const unitPerMsrProp = lineToWorkOn.Properties.find(
          (p) => p.Name === 'UnitsOfMeasurment'
        );

        if (unitPerMsrProp !== undefined) {
          if (
            Number(quantityProp.ValueAsObject) === 0 ||
            quantityProp['ItWasZero']
          ) {
            quantityProp['ItWasZero'] = true;
            quantityProp.ValueAsObject =
              Number(quantityProp.ValueAsObject) +
              quantity / unitPerMsrProp.ValueAsObject;

            lineToWorkOn.QuantityProp = lineToWorkOn.Properties.find(
              (p) =>
                p.Name === 'Quantity' ||
                p.Name === 'UoMCountedQuantity' ||
                p.Name == 'PickedQuantity'
            );
            lineToWorkOn.OpenQtyProp = lineToWorkOn.Properties.find(
              (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity'
            );
          }
        }
      } else {
        const newLine = RecordLine.addNewLine(
          recordModel,
          moduleStructure.module.Sections.find(
            (sc) => sc.XmlTagName === linesCat.Id
          ),
          undefined,
          moduleStructure.defaultValues,
          moduleStructure,
          this.layoutService
        );
        const itemCodeProp = newLine.Properties.find(
          (f) => f.Name === 'ItemCode'
        );
        itemCodeProp.ValueAsObject = itemCode;

        newLine.Properties.find((f) => f.Name === 'UoMEntry').ValueAsObject =
          uomEntry;

        newLine.Properties.find((f) => f.Name === 'UomCode').ValueAsObject =
          uomCode;

        newLine.Properties.find((f) => f.Name === 'Quantity').ValueAsObject =
          quantity;

        this.layoutService.triggerFieldValueChanged({
          recordModel,
          recordProperty: newLine.Properties.find((f) => f.Name === 'ItemCode'),
          formId: '',
          line: newLine.Id,
          sectionTagName: linesCat.Id,
          moduleStructure,
          internalTrigger: true,
        });

        const productDataRequest = [];

        productDataRequest.push({
          newLine,
          childCode: itemCode,
          field: moduleStructure.module.Sections.find(
            (sc) => sc.XmlTagName === linesCat.Id
          ).Fields.find((f) => f.FieldName === 'ItemCode'),
          args: {
            recordModel: recordModel,
            recordProperty: itemCodeProp,
            formId: '',
            line: newLine.Id,
            sectionTagName: 'Document_Lines',
            moduleStructure: moduleStructure,
          },
          treeType: '',
        });

        this.layoutService.loadModuleData(
          4,
          productDataRequest,
          [],
          true,
          false
        );
      }
    }
  }

  IsGoingToBeRemoved(args: LineDeletedArgs) {
    if (args.lineToDeleteIndex === -1) {
      return;
    }

    if (args.recordModel.ObjectKey === 'ITM_WMS_DEL_PLT') {
      const headerLine = args.recordModel.Categories.find(
        (cat) => cat.Id === 'ITM_WMS_DEL_PLT'
      ).Lines[0];

      const headerTotalPalletsProp = headerLine.Properties.find(
        (p) => p.Name === 'PLT_TO_DELIVER'
      );
      const headerScannedPalletsProp = headerLine.Properties.find(
        (p) => p.Name === 'SCANNED_PLT'
      );

      headerTotalPalletsProp.ValueAsObject =
        Number(headerTotalPalletsProp.ValueAsObject) + 1;

      headerScannedPalletsProp.ValueAsObject =
        Number(headerScannedPalletsProp.ValueAsObject) - 1;
    }
    if (args.recordModel.ObjectKey === 'ITM_WMS_PICK_HDR') {
      const headerLine = args.recordModel.Categories.find(
        (cat) => cat.Id === 'ITM_WMS_PICK_HDR'
      ).Lines[0];

      const headerOpenQtyProp = headerLine.Properties.find(
        (p) => p.Name === 'U_OPEN_QTY'
      );
      const headerPickedQtyProp = headerLine.Properties.find(
        (p) => p.Name === 'U_PICKED_QTY'
      );

      const qtyProp = args.lineToDelete.Properties.find(
        (p) => p.Name === 'U_QTY'
      );

      headerOpenQtyProp.ValueAsObject =
        Number(headerOpenQtyProp.ValueAsObject) + Number(qtyProp.ValueAsObject);

      headerPickedQtyProp.ValueAsObject =
        Number(headerPickedQtyProp.ValueAsObject) -
        Number(qtyProp.ValueAsObject);
    }
    if (args.recordModel.ObjectKey === 'ITM_WMS_PLT_BOX') {
      const linesSection = args.recordModel.Categories.find(
        (cat) => cat.Id === 'ITM_WMS_PLT_LINE'
      );

      for (let i = 0; i < linesSection.Lines.length; i++) {
        const properties = linesSection.Lines[i].Properties;
        const itemCodeProp = properties.find((p) => p.Name === 'U_ITEM_CODE');

        this.layoutService.triggerFieldValueChanged({
          recordProperty: itemCodeProp,
          formId: '',
          line: linesSection.Lines[i].Id,
          recordModel: args.recordModel,
          sectionTagName: 'ITM_WMS_PLT_LINE',
          moduleStructure: args.moduleStructure,
        });
      }
    }
  }
}
